import { getStickyCss } from 'common/components/entities/Section/utils/getStickyCss'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React, { memo } from 'react'
import { useThemeColor } from 'src/publisher/shared/hooks/use-theme-color'
import { CommonWebsiteHeader } from 'src/shared/entities/website-header'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'
import { WebsiteHeaderChildrenEntities } from './website-header-children-entities'

export interface WebsiteHeaderProps {
  entity: WebsiteHeaderInterface
}

export const WebsiteHeader = memo(({ entity }: WebsiteHeaderProps) => {
  const { headerAndFooter } = useThemeColor()
  const backgroundImage = getBackgroundImageStyleValue(
    headerAndFooter?.headerBackgroundPicture.file,
  )

  return (
    <StyleWrapper
      margin={{
        marginBottom: 0,
        marginLeft: 0,
        marginRight: 0,
        marginTop: 0,
      }}
      mobileMargin={{}}
      appearance={{
        mobile: true,
        desktop: true,
      }}
      additionalCss={{ ...getStickyCss(entity.sticky) }}
    >
      <CommonWebsiteHeader
        {...entity}
        backgroundImage={backgroundImage}
        background={headerAndFooter?.headerBackgroundPicture.background}
        backgroundColor={headerAndFooter?.headerBackgroundColor}
      >
        <WebsiteHeaderChildrenEntities childIds={entity.childIds} />
      </CommonWebsiteHeader>
    </StyleWrapper>
  )
})
